import { gridPaths } from '@/shared/hooks';
import { createEntityGridConfig, type GridConfig } from '@/ui/composites/grid/gridConfigFactory';
import { fetchProjectsGrid } from './gridQuery';
import type { GridFilterModel, GridSortModel } from '@/ui/primitives';
import type { ProjectDto } from '@flowqa/shared';

export const projectsGridConfig = ({
  initialSortModel,
  initialFilterModel,
  persistKey,
  syncStateToUrl = false,
  orgId,
}: {
  initialSortModel?: GridSortModel;
  initialFilterModel?: GridFilterModel;
  persistKey?: string | null;
  syncStateToUrl?: boolean;
  orgId?: string | null;
} = {}): GridConfig<ProjectDto> =>
  createEntityGridConfig<ProjectDto>({
    path: gridPaths.projects,
    queryFn: async () => await fetchProjectsGrid(orgId),
    noRowsText: 'No projects found',
    initialSortModel,
    initialFilterModel,
    persistKey,
    defaultPersistKey: 'projects',
    syncStateToUrl,
  });

export type ProjectsGridConfig = ReturnType<typeof projectsGridConfig>;
